import { Canvas, IEvent } from "fabric/fabric-impl";
import { fabric } from "fabric"
import { nodePalette } from "../../theme";
import Vector from "../Vector";
import ErrorNode from "../mana/nodes/action/logistics/ErrorNode";
import { red } from "@material-ui/core/colors";

export function drawLine(canvas: Canvas, from: any, to: any) {


	const STROKE_WIDTH = 4

	const line = new fabric.Line([
		0, 0, 0, 0
	], {
		selectable: false,
		stroke: nodePalette.connector,
		strokeWidth: STROKE_WIDTH,
		hoverCursor: 'auto',
		evented: false,
	})

	const triangle = new fabric.Triangle({
		originX: 'center',
		originY: 'center',
		stroke: nodePalette.border,
		strokeWidth: STROKE_WIDTH,
		hoverCursor: 'pointer',
		selectable: false,
		fill: nodePalette.background,
		width: 20,
		height: Math.sqrt(300),
		strokeLineCap: 'round',
		strokeLineJoin: 'round',
	})

	function render() {

		const difX = (to.left - from.left)
		const difY = (to.top - from.top)

		const ab = new Vector(difX, difY)
		const abAngle = ab.angle()

		const fromObj = from.linkedObject

		const paddingFrom = new Vector(fromObj.size / 2, 0)
		paddingFrom.rotate(abAngle)
		paddingFrom.x += from.left
		paddingFrom.y += from.top

		const toObj = to.linkedObject

		const paddingTo = new Vector(-toObj.size / 2, 0)
		paddingTo.rotate(abAngle)
		paddingTo.x += to.left
		paddingTo.y += to.top

		const paddedAb = new Vector(paddingTo.x - paddingFrom.x, paddingTo.y - paddingFrom.y)
		const middleX = paddingFrom.x + (paddedAb.x / 2)
		const middleY = paddingFrom.y + (paddedAb.y / 2)
		const angle = new Vector(middleX - from.left, middleY - from.top).angleDeg() + 90

		line.set({
			x1: (paddingFrom.x) - (STROKE_WIDTH / 2),
			y1: (paddingFrom.y) - (STROKE_WIDTH / 2),
			x2: (paddingTo.x) - (STROKE_WIDTH / 2),
			y2: (paddingTo.y) - (STROKE_WIDTH / 2),
		})

		triangle.set({
			left: middleX,
			top: middleY,
			angle
		})

		if (toObj instanceof ErrorNode) {
			line.set({
				stroke: red[100],
				strokeDashArray: [0, STROKE_WIDTH * 2],
				strokeLineCap: "round",
			})

			triangle.set({
				stroke: red[200],
				fill: red[100],
			})
		}

		canvas.requestRenderAll()
	}

	render()


	function handleMoving() {
		render()
	}

	const fromObj = from.linkedObject
	const toObj = to.linkedObject

	const subFrom = fromObj.onResize$.subscribe(handleMoving)
	const subTo = toObj.onResize$.subscribe(handleMoving)

	function removeLine() {

		from.off('moving', handleMoving)
		to.off('moving', handleMoving)

		subFrom.unsubscribe()
		subTo.unsubscribe()

		canvas.off('object:removed', handleDepRemoved)


		triangle.off()

		canvas.remove(line)
		canvas.remove(triangle)

		const fromObj = from.linkedObject
		const toObj = to.linkedObject
		if (fromObj && toObj) {
			fromObj.connections = fromObj.connections.filter((connection: any) => connection !== toObj)
		}
	}

	function handleDepRemoved(e: IEvent) {
		if ([from, to].includes(e.target)) {
			removeLine()
		}
	}

	from.on('moving', handleMoving)
	to.on('moving', handleMoving)

	canvas.on('object:removed', handleDepRemoved)

	triangle.on('mouseup', (e: any) => {
		if (e.button === 2) {
			removeLine()
			e.e.preventDefault()
			e.e.stopPropagation()
		}
	})

	canvas.add(line)
	canvas.add(triangle)
	canvas.sendToBack(triangle)
	canvas.sendToBack(line)
}